import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"
import AsyncStorage from "@react-native-async-storage/async-storage"
import { StudentUserGroup } from "students-api/types/groups"

interface GroupState {
  selectedGroupId: StudentUserGroup["groupId"] | null
  setSelectedGroupId: (groupId: StudentUserGroup["groupId"]) => void
  getCurrentGroup: (groups: StudentUserGroup[]) => StudentUserGroup | null
  clearGroup: () => void
}

export const useGroupStore = create<GroupState>()(
  persist(
    (set, get) => ({
      selectedGroupId: null,
      setSelectedGroupId: (groupId: StudentUserGroup["groupId"]) =>
        set({ selectedGroupId: groupId }),

      getCurrentGroup: (groups: StudentUserGroup[]) => {
        const { selectedGroupId } = get()

        return (
          groups.find((group) => group.groupId === selectedGroupId) ||
          groups[0] ||
          null
        )
      },

      clearGroup: () => {
        set({ selectedGroupId: null })
      },
    }),
    {
      name: "group-storage",
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
)
